// extracted by mini-css-extract-plugin
export default {"l":"ac1d790b72"};